import { mapGetters } from 'vuex';
import { Loading } from 'element-ui';
import DeviceDetector from "device-detector-js";
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import 'swiper/css/swiper.css';
import RoleCard from '@/components/RoleCard/RoleCard.vue';
import Navigation from '@/components/Navigation/Navigation.vue';
import AreaLoading from '@/components/AreaLoading/AreaLoading.vue';
import NoMoreData from '@/components/NoMoreData/NoMoreData.vue';
import Dialog from '@/components/Dialog/Dialog.vue';
import TabBar from '@/components/TabBar/TabBar.vue';
import OpenApp from '@/components/OpenApp/OpenApp.vue';
import { loadingIcon } from '@/svg';
import { loginout } from '@/api/login';
import { queryTopRoles, queryTabRoles, queryRolesFilterTabs } from '@/api/role';
import { report } from '@/api/report';
import { sendSMS } from '@/api/sms.js';
import { mixins } from '@/mixins';
import { getStorageData } from '@/utils/util';

export default {
  components: {
     Swiper,
     SwiperSlide,
     RoleCard,
     Navigation,
     AreaLoading,
     NoMoreData,
     Dialog,
     TabBar,
     OpenApp
  },
  
  name: 'Home',

  mixins: [mixins],

  data() {
    return {
      loadingIcon,
      pageLoading: false,
      unfiltered: false,
      showDialog: false,
      topList: [],
      tabList: [],
      roleList: [],
      activeTabId: '',
      page: 1,
      roleListLoading: false,
      nomoreData: false,
      swiperOption: {
        slidesPerView: 2,
        spaceBetween: 10,
        initialSlide: 0,
        centeredSlides: true,
        loop: true,
        effect : 'coverflow',
        coverflowEffect: {
          rotate: 30,
          stretch: 10,
          depth: 200,
          modifier: 2,
          slideShadows : true
        }
      }
    }
  },

  computed: {
    ...mapGetters(['userName', 'photo', 'isLogin', 'points', 'hasCampaignsNotify', 'inviteCode']),
  },

  created() {
    const unfiltered = localStorage.getItem('unfiltered') || '';

    this.unfiltered = unfiltered === '1';
    report({
      event_type: 'view',
      event_value: 'home_page'
    });
  },

  mounted() {
    this.init();

    try {
      const deviceDetector = new DeviceDetector();
      const deviceInfo = deviceDetector.parse(window.navigator.userAgent);
      
      report({
        event_type: 'home_os',
        event_value: `${deviceInfo.os.name}&${deviceInfo.os.version}`
      });
    }
    catch(err) {}
  },

  methods:{
    async init() {
      this.queryInitialData();

      if (!this.unfiltered) {
        this.unfilteredChange(true);
      }
    },

    unfilteredChange(value) {
      report({
        event_type: 'click',
        event_value: 'filter_switch'
      });

      if (value) {
        this.showDialog = true;
        this.$refs.over18dialog.show();
        return;
      }

      this.unfiltered = false;
      this.updateUnfiltered();
      this.resetSataus();
      this.queryInitialData();
    },

    over18() {
      report({
        event_type: 'click',
        event_value: 'over18'
      });
      this.$refs.over18dialog.hide();
      this.unfiltered = true;
      this.showDialog = false;
      this.updateUnfiltered();
      this.resetSataus();
      this.queryInitialData();
    },

    cancel18() {
      report({
        event_type: 'click',
        event_value: 'not18'
      });
      this.$refs.over18dialog.hide();
      this.unfiltered = false;
      this.showDialog = false;
      this.updateUnfiltered();
    },

    filterComfirm(button) {
      if (button.id === 'cancel18') {
        this.cancel18();
      }

      if (button.id === 'over18') {
        this.over18();
      }
    },

    updateUnfiltered() {
      localStorage.setItem('unfiltered', this.unfiltered ? '1' : '0');
    },

    resetSataus() {
      this.pageLoading = false;
      this.topList = [];
      this.tabList = [];
      this.roleList = [];
      this.activeTabId = '';
      this.page = 1;
      this.roleListLoading = false;
      this.nomoreData = false;
    },

    async queryInitialData() {
      this.pageLoading = true;
      const [topRoleRes, tabsRes] = await Promise.all([
        queryTopRoles({
          c: this.unfiltered ? 1 : 0
          // c: 0
        }),

        queryRolesFilterTabs({})
      ]);

      this.topList = this.makeTopRenderList(topRoleRes.data.list);
      this.pageLoading = false;
      this.tabList = this.makeTabRenderList(tabsRes.data.list);
      this.activeTabId = this.tabList[0].id;
      this.roleListLoading = true;
      await this.getRoleList({
        type: this.activeTabId,
        page: this.page,
        c: this.unfiltered ? 1 : 0
        // c: 0
      });
      this.roleListLoading = false;
    },

    async onClickCard(opts) {
      const inviteCode = this.inviteCode || '';

      this.$router.push({
        path: `/role_detail/${opts.id}`,
        query: {
          invite_code: inviteCode,
          nickname: encodeURIComponent(opts.nickName)
        }
      });
      report({
        event_type: 'click',
        event_value: 'role_card'
      });
    },

    async goCheckIn() {
      const inviteCode = this.inviteCode || '';

      this.$router.push({
        path: `/checkin`,
        query: {
          invite_code: inviteCode,
        }
      });
      report({
        event_type: 'click',
        event_value: 'home_checkin'
      });
    },

    async switchTab(cid) {
      report({
        event_type: 'click',
        event_value: 'tab_switch'
      });

      this.page = 1;
      this.nomoreData = false;
      this.activeTabId = cid;
      this.roleListLoading = true;
      this.roleList = [];
      await this.getRoleList({
        type: this.activeTabId,
        page: this.page,
        c: this.unfiltered ? 1 : 0,
        // c: 0
      });
      this.roleListLoading = false;
    },

    async getRoleList(opts) {
      const { type, page } = opts;
      const res = await queryTabRoles({
        type,
        page,
        page_size: 20,
        c: this.unfiltered ? 1 : 0,
        // c: 0
      });
      const list = this.makeRoleRenderList(res.data.list);

      if (!list.length) {
        this.nomoreData = true;
        return;
      }
      else {
        this.nomoreData = false;
      }

      this.roleList = this.roleList.concat(list);
    },

    async onScroll(event) {
      const { scrollTop, scrollHeight, clientHeight } = event.target;
      
      if (this.roleListLoading || this.nomoreData || this.pageLoading) {
        return;
      }

      if(scrollTop + clientHeight >= scrollHeight - 200) {
        this.page++;
        this.roleListLoading = true;
        report({
          event_type: 'view',
          event_value: 'role_scroll'
        });
        await this.getRoleList({
          type: this.activeTabId,
          page: this.page,
          c: this.unfiltered ? 1 : 0,
          // c: 0
        });
        this.roleListLoading = false;
      }
    },

    makeRoleRenderList(srcList) {
      const result = [];

      srcList.forEach((item) => {
        result.push({
          avatar: item.avatar.url,
          cover: item.cards[0].url,
          description: item.description,
          id: item.role_id,
          nickName: item.role_name,
          tags: item.tags,
          favCount: item.favorite_count
        });
      });

      return result;
    },

    makeTopRenderList(srcList) {
      const result = [];

      srcList.forEach((item) => {
        result.push({
          cover: item.cards[0].url,
          id: item.role_id,
          nickName: item.role_name,
          tags: item.tags
        });
      });

      return result;
    },

    makeTabRenderList(srcList) {
      const result = [];

      srcList.forEach((item) => {
        result.push({
          name: item.name,
          id: item.id,
        });
      });

      return result;
    },

    onSlideChange(){
      report({
        event_type: 'view',
        event_value: 'top_card'
      });
    }
  }
}
